export const CREATE_DATA_OBJECTS_UPLOAD_JOB_REQUEST = "CREATE_DATA_OBJECTS_UPLOAD_JOB_REQUEST";
export const CREATE_DATA_OBJECTS_UPLOAD_JOB_SUCCESS = "CREATE_DATA_OBJECTS_UPLOAD_JOB_SUCCESS";
export const CREATE_DATA_OBJECTS_UPLOAD_JOB_FAILURE = "CREATE_DATA_OBJECTS_UPLOAD_JOB_FAILURE";

export const GET_DATA_OBJECTS_BY_DATASET_ID_REQUEST = "GET_DATA_OBJECTS_BY_DATASET_ID_REQUEST";
export const GET_DATA_OBJECTS_BY_DATASET_ID_SUCCESS = "GET_DATA_OBJECTS_BY_DATASET_ID_SUCCESS";
export const GET_DATA_OBJECTS_BY_DATASET_ID_FAILURE = "GET_DATA_OBJECTS_BY_DATASET_ID_FAILURE";

export const GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_REQUEST = "GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_REQUEST"
export const GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_SUCCESS = "GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_SUCCESS"
export const GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_FAILURE = "GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_FAILURE"

export const GET_DATA_OBJECT_REQUEST = "GET_DATA_OBJECT_REQUEST";
export const GET_DATA_OBJECT_SUCCESS = "GET_DATA_OBJECT_SUCCESS";
export const DATA_OBJECT_PUSHED = "DATA_OBJECT_PUSHED";
export const GET_DATA_OBJECT_FAILURE = "GET_DATA_OBJECT_FAILURE";

export const CREATE_DATA_OBJECT_REQUEST = "CREATE_DATA_OBJECT_REQUEST";
export const CREATE_DATA_OBJECT_SUCCESS = "CREATE_DATA_OBJECT_SUCCESS";
export const CREATE_DATA_OBJECT_FAILURE = "CREATE_DATA_OBJECT_FAILURE";

export const UPDATE_DATA_OBJECT_REQUEST = "UPDATE_DATA_OBJECT_REQUEST";
export const UPDATE_DATA_OBJECT_SUCCESS = "UPDATE_DATA_OBJECT_SUCCESS";
export const UPDATE_DATA_OBJECT_FAILURE = "UPDATE_DATA_OBJECT_FAILURE";

export const DELETE_DATA_OBJECT_REQUEST = "DELETE_DATA_OBJECT_REQUEST";
export const DELETE_DATA_OBJECT_SUCCESS = "DELETE_DATA_OBJECT_SUCCESS";
export const DELETE_DATA_OBJECT_FAILURE = "DELETE_DATA_OBJECT_FAILURE";

export const GET_DATA_OBJECT_PERMISSIONS_REQUEST = "GET_DATA_OBJECT_PERMISSIONS_REQUEST";
export const GET_DATA_OBJECT_PERMISSIONS_SUCCESS = "GET_DATA_OBJECT_PERMISSIONS_SUCCESS";
export const GET_DATA_OBJECT_PERMISSIONS_FAILURE = "GET_DATA_OBJECT_PERMISSIONS_FAILURE";

export const GET_DATA_OBJECT_BY_UUID_REQUEST = "GET_DATA_OBJECT_BY_UUID_REQUEST";
export const GET_DATA_OBJECT_BY_UUID_SUCCESS = "GET_DATA_OBJECT_BY_UUID_SUCCESS";
export const GET_DATA_OBJECT_BY_UUID_FAILURE = "GET_DATA_OBJECT_BY_UUID_FAILURE";

export const GET_DATA_OBJECT_SHARED_LINK_REQUEST = "GET_DATA_OBJECT_SHARED_LINK_REQUEST";
export const GET_DATA_OBJECT_SHARED_LINK_SUCCESS = "GET_DATA_OBJECT_SHARED_LINK_SUCCESS";
export const GET_DATA_OBJECT_SHARED_LINK_FAILURE = "GET_DATA_OBJECT_SHARED_LINK_FAILURE";

export const GET_SHARED_DATA_OBJECT_BY_UUID_REQUEST = "GET_SHARED_DATA_OBJECT_BY_UUID_REQUEST";

export const UPDATE_SHARED_DATA_OBJECT_REQUEST = "UPDATE_SHARED_DATA_OBJECT_REQUEST";

export const UPDATE_DATA_OBJECT_VALIDATION_ERRORS_REQUEST = "UPDATE_DATA_OBJECT_VALIDATION_ERRORS_REQUEST";

export const GET_UNMASKED_DATA_BY_UUID_REQUEST = "GET_UNMASKED_DATA_BY_UUID_REQUEST";
export const GET_UNMASKED_DATA_BY_UUID_SUCCESS = "GET_UNMASKED_DATA_BY_UUID_SUCCESS";
export const GET_UNMASKED_DATA_BY_UUID_FAILURE = "GET_UNMASKED_DATA_BY_UUID_FAILURE";
export const CLEAR_UNMASKED_DATA = "CLEAR_UNMASKED_DATA";

export const GET_AI_MAPPING_SUGGESTION_REQUEST = "GET_AI_MAPPING_SUGGESTION_REQUEST";
export const GET_AI_MAPPING_SUGGESTION_SUCCESS = "GET_AI_MAPPING_SUGGESTION_SUCCESS";
export const GET_AI_MAPPING_SUGGESTION_FAILURE = "GET_AI_MAPPING_SUGGESTION_FAILURE";

export const RESET_AI_MAPPING_SUGGESTION = "RESET_AI_MAPPING_SUGGESTION";

export const SEARCH_DATASET_DATA_OBJECTS_REQUEST = "SEARCH_DATASET_DATA_OBJECTS_REQUEST";
export const SEARCH_DATASET_DATA_OBJECTS_SUCCESS = "SEARCH_DATASET_DATA_OBJECTS_SUCCESS";
export const SEARCH_DATASET_DATA_OBJECTS_FAILURE = "SEARCH_DATASET_DATA_OBJECTS_FAILURE";

export const CLEAR_SEARCH_DATASET_DATA_OBJECTS = "CLEAR_SEARCH_DATASET_DATA_OBJECTS";

export const createDataObjectsUploadJobRequest = (businessAreaId, schemaId, dataSet, dataUploadOptions, file, fieldMappings) => ({
    type: CREATE_DATA_OBJECTS_UPLOAD_JOB_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSet,
        dataUploadOptions,
        file,
        fieldMappings
    }
})

export const createDataObjectsUploadJobSuccess = () => ({
    type: CREATE_DATA_OBJECTS_UPLOAD_JOB_SUCCESS
})

export const createDataObjectsUploadJobFailure = (error) => ({
    type: CREATE_DATA_OBJECTS_UPLOAD_JOB_FAILURE,
    payload: {
        error
    }
})

export const getDataObjectsByDataSetIdRequest = (businessAreaId, schemaId, dataSetId) => ({
    type: GET_DATA_OBJECTS_BY_DATASET_ID_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId
    }
})

export const getDataObjectsByDataSetIdSuccess = (dataObjectsResult) => ({
    type: GET_DATA_OBJECTS_BY_DATASET_ID_SUCCESS,
    payload: {
        dataObjectsResult
    }
})

export const getDataObjectsByDataSetIdFailure = (error) => ({
    type: GET_DATA_OBJECTS_BY_DATASET_ID_FAILURE,
    payload: {
        error
    }
})

export const getDataObjectsByDataSetIdNextPageRequest = (businessAreaId, schemaId, dataSetId, pageKey) => ({
    type: GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId,
        pageKey
    }
})

export const getDataObjectsByDataSetIdNextPageSuccess = (dataObjectsResult) => ({
    type: GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_SUCCESS,
    payload: {
        dataObjectsResult
    }
})

export const getDataObjectsByDataSetIdNextPageFailure = (error) => ({
    type: GET_DATA_OBJECTS_BY_DATASET_ID_NEXT_PAGE_FAILURE,
    payload: {
        error
    }
})

export const getDataObjectRequest = (businessAreaId, schemaId, dataSetId, dataObjectId) => ({
    type: GET_DATA_OBJECT_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId,
        dataObjectId
    }
})

export const getDataObjectSuccess = (dataObject) => ({
    type: GET_DATA_OBJECT_SUCCESS,
    payload: {
        dataObject
    }
})

// A record's update pushed by the server: it replaces its row, and the open record only when that
// is the same record.
export const dataObjectPushed = (dataObject) => ({
    type: DATA_OBJECT_PUSHED,
    payload: {
        dataObject
    }
})

export const getDataObjectFailure = (error) => ({
    type: GET_DATA_OBJECT_FAILURE,
    payload: {
        error
    }
})

export const createDataObjectRequest = (businessAreaId, schemaId, dataSetId, dataObject) => ({
    type: CREATE_DATA_OBJECT_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId,
        dataObject
    }
})

export const createDataObjectSuccess = (dataObject) => ({
    type: CREATE_DATA_OBJECT_SUCCESS,
    payload: {
        dataObject
    }
})

export const createDataObjectFailure = (error) => ({
    type: CREATE_DATA_OBJECT_FAILURE,
    payload: {
        error
    }
})

export const updateDataObjectRequest = (businessAreaId, schemaId, dataSetId, dataObjectId, dataObject) => ({
    type: UPDATE_DATA_OBJECT_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId,
        dataObjectId,
        dataObject
    }
})

export const updateDataObjectSuccess = (dataObjectId, dataObject) => ({
    type: UPDATE_DATA_OBJECT_SUCCESS,
    payload: {
        dataObjectId,
        dataObject
    }
})

export const updateDataObjectFailure = (error) => ({
    type: UPDATE_DATA_OBJECT_FAILURE,
    payload: {
        error
    }
})

export const deleteDataObjectRequest = (businessAreaId, schemaId, dataSetId, dataObjectId) => ({
    type: DELETE_DATA_OBJECT_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId,
        dataObjectId
    }
})

export const deleteDataObjectSuccess = (businessAreaId, schemaId, dataSetId, dataObjectId) => ({
    type: DELETE_DATA_OBJECT_SUCCESS,
    payload: {
        businessAreaId,
        schemaId,
        dataSetId,
        dataObjectId
    }
})

export const deleteDataObjectFailure = (error) => ({
    type: DELETE_DATA_OBJECT_FAILURE,
    payload: {
        error
    }
})

export const updateDataObjectValidationErrorsRequest = (dataObject, validationErrors) => ({
    type: UPDATE_DATA_OBJECT_VALIDATION_ERRORS_REQUEST,
    params: {
        dataObject,
        validationErrors
    }
})

export const getDataObjectPermissionRequest = () => ({
    type: GET_DATA_OBJECT_PERMISSIONS_REQUEST
})

export const getDataObjectPermissionSuccess = (permission) => ({
    type: GET_DATA_OBJECT_PERMISSIONS_SUCCESS,
    payload: {
        permission
    }
})

export const getDataObjectPermissionFailure = (error) => ({
    type: GET_DATA_OBJECT_PERMISSIONS_FAILURE,
    payload: {
        error
    }
})

export const getDataObjectByUUIDRequest = (dataObjectId) => ({
    type: GET_DATA_OBJECT_BY_UUID_REQUEST,
    params: {
        dataObjectId
    }
})

export const getDataObjectByUUIDSuccess = (result) => ({
    type: GET_DATA_OBJECT_BY_UUID_SUCCESS,
    payload: {
        result
    }
})

export const getDataObjectByUUIDFailure = (error) => ({
    type: GET_DATA_OBJECT_BY_UUID_FAILURE,
    payload: {
        error
    }
})

export const getDataObjectSharedLinkRequest = (businessAreaId, schemaId, dataSetId, dataObjectId, expires, readOnly) => ({
    type: GET_DATA_OBJECT_SHARED_LINK_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId,
        dataObjectId,
        readOnly,
        expires
    }
})

export const getDataObjectSharedLinkSuccess = (result) => ({
    type: GET_DATA_OBJECT_SHARED_LINK_SUCCESS,
    payload: {
        result
    }
})

export const getDataObjectSharedLinkFailure = (error) => ({
    type: GET_DATA_OBJECT_SHARED_LINK_FAILURE,
    payload: {
        error
    }
})

export const getSharedDataObjectByUUIDRequest = (tenantId, userId, readOnly, expiresAt, signatureDate, signature, dataObjectId) => ({
    type: GET_SHARED_DATA_OBJECT_BY_UUID_REQUEST,
    params: {
        tenantId,
        userId,
        readOnly,
        expiresAt,
        signatureDate,
        signature,
        dataObjectId
    }
})

export const updateSharedDataObjectRequest = (tenantId, userId, readOnly, expiresAt, signatureDate, signature, businessAreaId, schemaId, dataSetId, dataObjectId, dataObject) => ({
    type: UPDATE_SHARED_DATA_OBJECT_REQUEST,
    params: {
        tenantId,
        userId,
        readOnly,
        expiresAt,
        signatureDate,
        signature,
        businessAreaId,
        schemaId,
        dataSetId,
        dataObjectId,
        dataObject
    }
})

export const getUnmaskedDataByUUIDRequest = (dataObjectId) => ({
    type: GET_UNMASKED_DATA_BY_UUID_REQUEST,
    params: { dataObjectId },
});

export const getUnmaskedDataByUUIDSuccess = (result) => ({
    type: GET_UNMASKED_DATA_BY_UUID_SUCCESS,
    payload: { result },
});

export const getUnmaskedDataByUUIDFailure = (error) => ({
    type: GET_UNMASKED_DATA_BY_UUID_FAILURE,
    payload: { error },
});

export const clearUnmaskedData = () => ({
    type: CLEAR_UNMASKED_DATA,
});

export const getAiMappingSuggestionRequest = (businessAreaId, schemaId, dataSet, fileReadResult, schemaModel) => ({
    type: GET_AI_MAPPING_SUGGESTION_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSet,
        fileReadResult,
        schemaModel,
    },
});

export const getAiMappingSuggestionSuccess = (aiMappingSuggestion) => ({
    type: GET_AI_MAPPING_SUGGESTION_SUCCESS,
    payload: {
        aiMappingSuggestion,
    },
});

export const getAiMappingSuggestionFailure = (error) => ({
    type: GET_AI_MAPPING_SUGGESTION_FAILURE,
    payload: {
        error,
    },
});

export const resetAiMappingSuggestion = () => ({
    type: RESET_AI_MAPPING_SUGGESTION,
});

export const searchDataSetDataObjectsRequest = (businessAreaId, schemaId, dataSetId, query) => ({
    type: SEARCH_DATASET_DATA_OBJECTS_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId,
        query
    }
});

export const searchDataSetDataObjectsSuccess = (dataObjectsResult) => ({
    type: SEARCH_DATASET_DATA_OBJECTS_SUCCESS,
    payload: {
        dataObjectsResult
    }
});

export const searchDataSetDataObjectsFailure = (error) => ({
    type: SEARCH_DATASET_DATA_OBJECTS_FAILURE,
    payload: {
        error
    }
});

export const clearSearchDataSetDataObjects = () => ({
    type: CLEAR_SEARCH_DATASET_DATA_OBJECTS,
});

export const GET_DATASET_DESCRIPTION_REQUEST = "GET_DATASET_DESCRIPTION_REQUEST";
export const GET_DATASET_DESCRIPTION_SUCCESS = "GET_DATASET_DESCRIPTION_SUCCESS";
export const GET_DATASET_DESCRIPTION_FAILURE = "GET_DATASET_DESCRIPTION_FAILURE";
export const RESET_DATASET_DESCRIPTION = "RESET_DATASET_DESCRIPTION";

export const getDatasetDescriptionRequest = (businessAreaId, schemaId, dataSetId, regenerate = false) => ({
    type: GET_DATASET_DESCRIPTION_REQUEST,
    params: {
        businessAreaId,
        schemaId,
        dataSetId,
        regenerate,
    },
});

export const getDatasetDescriptionSuccess = (datasetDescription) => ({
    type: GET_DATASET_DESCRIPTION_SUCCESS,
    payload: {
        datasetDescription,
    },
});

export const getDatasetDescriptionFailure = (error) => ({
    type: GET_DATASET_DESCRIPTION_FAILURE,
    payload: {
        error,
    },
});

export const resetDatasetDescription = () => ({
    type: RESET_DATASET_DESCRIPTION,
});

export const SET_AI_HIGHLIGHTED_DATA_OBJECTS = "SET_AI_HIGHLIGHTED_DATA_OBJECTS";
export const CLEAR_AI_HIGHLIGHTED_DATA_OBJECTS = "CLEAR_AI_HIGHLIGHTED_DATA_OBJECTS";

export const setAiHighlightedDataObjects = (dataObjectIds) => ({
    type: SET_AI_HIGHLIGHTED_DATA_OBJECTS,
    payload: { dataObjectIds: Array.isArray(dataObjectIds) ? dataObjectIds : [] },
});

export const clearAiHighlightedDataObjects = () => ({
    type: CLEAR_AI_HIGHLIGHTED_DATA_OBJECTS,
});
